const PHP_SYMBOL = '₱';
const MINUS_SIGN = '−';
const PRECISION = 2;

const amountFormat = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: PRECISION,
  maximumFractionDigits: PRECISION,
});

const formatPhp = (rawValue?: number | string): string => {
  const numericValue =
    typeof rawValue === 'string' ? Number.parseFloat(rawValue) : rawValue;
  const value = Number.isFinite(numericValue) ? (numericValue as number) : 0;

  const factor = 10 ** PRECISION;
  const rounded = Math.round((value + Number.EPSILON) * factor) / factor;
  const sign = rounded < 0 ? MINUS_SIGN : '';

  return `${sign}${PHP_SYMBOL}${amountFormat.format(Math.abs(rounded))}`;
};

type Props = {
  value?: number | string;
  className?: string;
};

export const MoneyPh = ({ value, className }: Props) => (
  <span className={className}>{formatPhp(value)}</span>
);
